export default  [
  {
    key: "date",
    label: "Date",
    sortable: true
  },

  {
    key: "shift_start",
    label: "Shift Start",
    sortable: true
  },

  {
    key: "shift_end",
    label: "Shift End",
    sortable: true
  },

  {
    key: "plan",
    label: "Plan",
    sortable: true
  },

  {
    key: "device",
    label: "Device",
    sortable: true
  },

  {
    key: "owner",
    label: "Device",
    sortable: true
  },

  {
    key: "contract",
    label: "Contract",
    sortable: true
  },

  {
    key: "should_serve",
    label: "Route",
    sortable: true
  },

  {
    key: "not_served",
    label: "Not Served",
    sortable: true
  },

  {
    key: "served",
    label: "Served",
    sortable: true
  },

  {
    key: "percent",
    label: "Percent",
    sortable: true
  },


]